module.exports = __webpack_public_path__ + "img/lobby.5e9da46d.png";